import { Sparkles } from 'lucide-react'

interface EsmaCardProps {
  esma: {
    id: number
    name: string
    meaning: string
    eq_domain: string
    description: string
  }
  onClick?: () => void
}

export default function EsmaCard({ esma, onClick }: EsmaCardProps) {
  // EQ domain renkleri
  const domainColors: Record<string, string> = {
    compassion: 'bg-pink-100 text-pink-700',
    wisdom: 'bg-purple-100 text-purple-700',
    IQ: 'bg-blue-100 text-blue-700',
    healing: 'bg-green-100 text-green-700',
    creativity: 'bg-yellow-100 text-yellow-700',
    security: 'bg-gray-100 text-gray-700',
    power: 'bg-red-100 text-red-700',
    provision: 'bg-orange-100 text-orange-700',
    patience: 'bg-teal-100 text-teal-700',
    guidance: 'bg-indigo-100 text-indigo-700',
    justice: 'bg-cyan-100 text-cyan-700',
    majesty: 'bg-violet-100 text-violet-700',
    peace: 'bg-emerald-100 text-emerald-700',
    sovereignty: 'bg-amber-100 text-amber-700',
    honor: 'bg-rose-100 text-rose-700',
    humility: 'bg-slate-100 text-slate-700',
    honesty: 'bg-lime-100 text-lime-700',
    purity: 'bg-sky-100 text-sky-700',
  }

  const colorClass = domainColors[esma.eq_domain] || 'bg-gray-100 text-gray-700'

  return (
    <div
      className="card hover:shadow-lg transition-shadow cursor-pointer"
      onClick={onClick}
    >
      <div className="card-body p-4">
        {/* Esma adi */}
        <div className="flex items-center gap-2 mb-2">
          <Sparkles size={20} style={{ color: 'var(--primary-color)' }} />
          <h3 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>
            {esma.name}
          </h3>
        </div>

        {/* Anlam */}
        <p className="text-sm mb-3" style={{ color: 'var(--text-secondary)' }}>
          {esma.meaning}
        </p>

        {/* EQ Domain badge */}
        <div className="flex items-center justify-between">
          <span className={`badge ${colorClass} px-3 py-1 rounded-full text-xs font-medium`}>
            {esma.eq_domain}
          </span>
        </div>
      </div>
    </div>
  )
}
